import { makeAutoObservable, runInAction } from 'mobx';
import { IShop } from '../../../models/User';
import PortalService from '../../../services/api/user-service';
import { rootContainer, TYPE } from '../../../services/container/root';
import SubscriptionPlanEditorStore from "./subscription-plan-editor-store";

class AssignShopsToPlanStore {
    private _isProcessing: boolean = false;
    private _selectedShops: IShop[] = [];
    private _assignedShops: IShop[] = [];

    constructor(private _plan: SubscriptionPlanEditorStore, private _featuresInfo: string) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    get plan() {
        return this._plan;
    }

    get featuresInfo() {
        return this._featuresInfo;
    }

    public get isProcessing(): boolean {
        return this._isProcessing;
    }

    public get assignedShops(): IShop[] {
        return this._assignedShops;
    }

    private get service(): PortalService {
        return rootContainer.get<PortalService>(TYPE.UserService);
    }


    private async _assignPlanToShops(): Promise<boolean> {
        if(!this._plan.id) {
            console.error('cannot assign to not yet saved plan');
            return false;
        }

        this._isProcessing = true;
        const shopIds = this._selectedShops?.map(s => s.id);
        if (shopIds) {
            try {
                let result = await this.service.assignPlanToShops(this._plan.id, shopIds);
                runInAction(() => {
                    this._isProcessing = false;
                    this._assignedShops = result;
                });
                return true;
            }
            catch (e) {
                runInAction(() => {
                    this._isProcessing = false;
                });                
            }            
        }
        return false;
    }

    public async assignPlanToShops() {
        const assigned = await this._assignPlanToShops();
        if (assigned) {
            await this.plan.refresh();
        }
    }

    public get selectedShops() {
        return this._selectedShops;
    }

    public setSelectedShops(list: IShop[]) {
        this._selectedShops = list;
    }
}

export default AssignShopsToPlanStore;
